<template>
  <b-card>

    <!-- media -->
    <b-media no-body>
      <b-media-aside>
        <b-link @click="$refs.refInputEl.$el.click()">
          <b-avatar
            ref="previewEl"
            variant="light-primary"
            badge
            class="badge-minimal"
            badge-variant="success"
            :src="generalData.avatar"
            height="60"
          />
        </b-link>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-form-file
          ref="refInputEl"
          v-model="form.avatar"
          accept=".jpg, .png, .gif"
          :hidden="true"
          plain
          @input="inputImageRenderer"
        />
        <!--/ upload button -->
        <b-card-text>{{ $t('Allowed JPG, GIF or PNG. Max size of 1MB') }}</b-card-text>
      </b-media-body>
    </b-media>
    <!--/ media -->

    <validation-observer
      ref="userUpdateForm"
      #default="{ invalid }"
    >
      <!-- form -->
      <b-form
        class="mt-2"
        @submit.prevent="submit"
      >
        <b-row>
          <b-col sm="6">
            <b-form-group
              :label="$t('Username')"
              label-for="username"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Username')"
                vid="username"
                rules="required"
              >
                <b-form-input
                  v-model="form.username"
                  :placeholder="$t('Username')"
                  name="username"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Name')"
              label-for="name"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Name')"
                vid="name"
                rules="required"
              >
                <b-form-input
                  v-model="form.name"
                  name="name"
                  :placeholder="$t('Name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Email')"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Email')"
                vid="email"
                rules="email"
              >
                <b-form-input
                  v-model="form.email"
                  name="email"
                  :placeholder="$t('Email')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('Mobile')"
              label-for="mobile"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Mobile')"
                vid="mobile"
                rules="required"
              >
                <b-form-input
                  v-model="form.mobile"
                  name="company"
                  :placeholder="$t('Mobile')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              class="mt-2 mr-1"
            >
              {{ $t('Save changes') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              type="reset"
              class="mt-2"
              @click.prevent="resetForm"
            >
              {{ $t('Reset') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BAvatar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  components: {
    BButton,
    BForm,
    BAvatar,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: null,
        username: null,
        mobile: null,
        email: null,
        avatar: null,
      },
      // validation rules
      required,
      email,
    }
  },
  created() {
    this.resetForm()
  },
  methods: {
    submit() {
      this.$refs.userUpdateForm.validate().then(success => {
        if (success) {
          return this.$emit('onFormSubmit', this.form)
        }
        return success
      })
    },
    resetForm() {
      this.form = {
        name: this.generalData.name,
        username: this.generalData.username,
        mobile: this.generalData.mobile,
        email: this.generalData.email,
        avatar: null,
      }
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, result => {
      previewEl.value.src = result
    })
    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>
